<template>
    <div class="flexContainer full">
        <loader :loading="loading"></loader>
        <section id="sectionPrincipal" class="flexContainer fd-c full t-fd-r t-fw-nw">
            <section class="planosWrapper flexContainer jc-sb">
                <section class="searchResultsWrapper size3of4 flexContainer fd-c">
                    <section>
                        <div class="flexContainer ai-c jc-sb">
                            <div class="flexContainer ai-c jc-sb">
                                <div class="btnExp iBlock pointer mobileNot txtCenter active fright uppercase" @click="showModal();">
                                    {{ $t("standDesign.create") }}
                                </div>
                            </div>
                        </div>
                        <hr class="full mt10 separator" />
                        <transition-group name="fade" class="resultsWrapper flexContainer fw-w">
                            <div
                                v-for="standDesign in standDesignList"
                                :key="standDesign.name"
                                v-if="standDesign.active !== false"
                                class="listDisplay rel full flexContainer fd-c ai-c jc-fs"
                            >
                                <div class="listDisplay rel full flexContainer fd-c ai-c jc-fs list">
                                    <div class="listDisplay full ai-c jc-sb flexContainer">
                                        <div class="flexContainer fd-c size1of5">
                                            <span class="listTitle center">{{ standDesign.name }} </span>
                                        </div>
                                        <div class="flexContainer fd-c size1of5">
                                            <span v-if="standDesign.createdBy && standDesign.createdBy.firstname" class="center"
                                                >{{ $t("planoList.created") }} {{ standDesign.createdBy.firstname }}
                                                {{ standDesign.createdBy.lastname }}</span
                                            >
                                            <span v-if="standDesign.createdBy && standDesign.createdBy.firstname" class="center"
                                                >{{ $t("planoList.modified") }} {{ standDesign.modifiedBy.firstname }}
                                                {{ standDesign.modifiedBy.lastname }}</span
                                            >
                                        </div>
                                        <div class="flexContainer fd-c size1of5">
                                            <span v-if="standDesign.description !== null" class="center">{{ standDesign.description }}</span>
                                        </div>
                                        <div class="flexContainer fd-c size1of5">
                                            <button class="btn editBtn abs center" @click="editStandDesign(standDesign);">
                                                {{ $t("editCampaign.edit") }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </transition-group>
                    </section>
                </section>
            </section>
            <CreateStandDesign v-if="createStandDesign" @createStandDesign="modalClose($event);"></CreateStandDesign>
            <EditStandDesign v-if="editStand" @editStandDesign="modalClose($event);"></EditStandDesign>
        </section>
    </div>
</template>

<script>
import EditCampaign from "../campaign/EditCampaign.vue";
import httpService from "../service";
import { mapActions } from "vuex";
import CreateStandDesign from "../admin/CreateStandDesign.vue";
import EditStandDesign from "../admin/EditStandDesign.vue";
import loader from "@/components/loader/loader";

export default {
    components: {
        EditCampaign,
        CreateStandDesign,
        EditStandDesign,
        loader
    },
    data: () => ({
        loading: false,
        campaign: {},
        createStandDesign: false,
        standDesignList: {},
        editStand: false
    }),
    methods: {
        ...mapActions({
            setStandDesign: "items/setStandDesign"
        }),
        modalClose(close) {
            this.createStandDesign = close;
            this.editStand = close;
        },
        showModal() {
            this.createStandDesign = true;
        },
        editStandDesign(a) {
            this.editStand = true;
            this.setStandDesign(a);
        },
        async getStandDesignList() {
            this.loading = true;
            try {
                const res = await httpService.get("/admin/standDesigns/list");
                this.standDesignList = res.data;
            } catch (e) {
                this.dialogError(e);
            } finally {
                this.loading = false;
            }
        }
    },
    created() {
        this.getStandDesignList();
    }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// standList.vue?225a1154